import React from 'react';
import { translate } from 'react-i18next';

import ValidationMessage from 'components/account/ValidationMessage.js';

// Multi-select sibling of EsotericRadioButton.js, which only ever supports
// one selected value at a time (radio semantics). Multi-format notifications
// let an employee pick more than one alternate channel (e.g. both sms and
// email) alongside push, so this renders one checkbox per option instead,
// backed by array-membership rather than single-value equality.
class NotificationChannelCheckboxes extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  validateContactRequirements(channel) {
    if (channel !== 'sms') {
      return false;
    }
    return (
      (this.props.user[0] && !this.props.user[0].data.phone_number)
      || (this.props.user.phone_number === '' || this.props.user.phone_number === null)
    );
  }

  handleChange(channel) {
    this.props.onSettingsChange(this.props.name, channel);
  }

  render() {
    const currentPreference = this.props.currentPreference || [];
    const lockedChannels = this.props.lockedChannels || [];
    const isLocked = lockedChannels.length > 0;

    return (
      <div className="notificationChannelCheckboxes">
        {this.props.validOptions.map((channel) => {
          // Locked: show what will actually be delivered (the company's
          // required channels), not the employee's own stored preference,
          // and don't let them change it here.
          const checked = isLocked
            ? lockedChannels.includes(channel)
            : currentPreference.includes(channel);
          const missingContactInfo = !isLocked && this.validateContactRequirements(channel);
          const disabled = isLocked || missingContactInfo;
          return (
            <div key={channel} className={disabled ? 'disabled' : ''}>
              <label className={checked ? 'checked' : ''}>
                <input
                  type="checkbox"
                  disabled={disabled}
                  name={this.props.name}
                  className={channel}
                  checked={checked}
                  value={channel}
                  onChange={() => this.handleChange(channel)}
                />
                {this.props.t(`EsotericRadioButton.${channel}`)}
              </label>
              {missingContactInfo && (
                <div className="validation-message message hint">
                  <span>
                    {this.props.t('NotificationChoices.enter_valid_phone')}
                    {' '}
                  </span>
                  <ValidationMessage
                    onClickHandler={this.props.contactInfoCallbackHandler}
                    activePage={this.props.activePage}
                    section="contact"
                    text={this.props.t('NotificationChoices.contact_info')}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default translate()(NotificationChannelCheckboxes);
